import { useCallback, useContext } from 'react'
import { PatternContext } from '../contexts/PatternContext'
import Indicator, { IndicatorType } from '../condition/indicators/types/Indicator'
import Open from '../condition/indicators/candle/Open'
import High from '../condition/indicators/candle/High'
import Low from '../condition/indicators/candle/Low'
import Close from '../condition/indicators/candle/Close'
import Value from '../condition/indicators/Value'

function useIndicatorRHS() {
  const { startingIndicators } = useContext(PatternContext)

  const getRHS = useCallback(
    (indicator: Indicator, field?: string) => {
      const rhsPriceIndicators = [Open, High, Low, Close, Value]

      if (field?.endsWith('Angle')) {
        if (indicator.type === IndicatorType.OVERLAY) {
          const overlayIndicatorsWithAngle = startingIndicators
            .map((startingIndicator) => ({
              ...startingIndicator,
              fields: startingIndicator.fields.filter((field) => field.endsWith('Angle')),
            }))
            .filter(
              (startingIndicator) =>
                startingIndicator.type === IndicatorType.OVERLAY &&
                startingIndicator.fields.length > 0
            )

          return [...overlayIndicatorsWithAngle, Value]
        }

        return [Value]
      }

      switch (indicator.type) {
        case IndicatorType.PRICE:
          return rhsPriceIndicators
        case IndicatorType.OVERLAY:
          const overlayIndicators = startingIndicators.filter(
            (startingIndicator) => startingIndicator.type === IndicatorType.OVERLAY
          )
          return [...overlayIndicators, ...rhsPriceIndicators]
        case IndicatorType.OSCILLATOR:
          if (indicator.excludeSelfInRHS) {
            return [Value]
          } else {
            return [{ ...indicator }, Value]
          }
        default:
          return []
      }
    },
    [startingIndicators]
  )

  return {
    getRHS,
  }
}

export default useIndicatorRHS
